import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    OnInit,
    OnDestroy,
    Output,
    EventEmitter,
    Renderer2
} from '@angular/core';
import {EntityService, EntityPageService} from "@signature-it/ngx-entity/services";
import {DomSanitizer} from "@angular/platform-browser";
import {ActivatedRoute} from '@angular/router';
import {Subscription} from "rxjs";
import {EntityPageBaseComponent} from "@signature-it/ngx-entity/pages/entity-page-base";
declare let _ : any;

@Component({
    selector: 'entity-block',
    templateUrl: './entity-block.component.html',
    styleUrls: ['./entity-block.component.scss'],
    standalone: false
})
export class EntityBlockComponentGeneric extends EntityPageBaseComponent implements OnInit, OnChanges, OnDestroy {
    @Input() uri: string;
    @Input() entityType: string;
    @Input() entityVar: string;
    @Input() refreshHtml: boolean = false;
    @Input() resetDataOnChanges: boolean = false;
	@Input() fallBackEntityVar: string;
    @Input() mainDocRelated: string;
    @Input() isSolr: boolean = false;
    @Input() tokenArray;
    @Output() loadBlock: EventEmitter<boolean> = new EventEmitter<boolean>();
    mainDocRelatedVar;
    subscriptionsList$: Array<Subscription> = [];
    scriptsReg = /<script\b[^>]*>[\s\S]*?<\/script\b[^>]*>/g;

     constructor( protected entityService: EntityService,
                  private sanitizer:DomSanitizer,
                  protected route: ActivatedRoute,
                  protected entityPageService: EntityPageService,
                  private renderer: Renderer2) {
         super();
     }

     ngOnInit() {
         // this.getBlock();
         this.renderer.addClass(document.body, 'has-eb-'+this.entityVar);
     }

    ngOnDestroy() {
        this.renderer.removeClass(document.body, 'has-eb-'+this.entityVar);
        this.subscriptionsList$.forEach(s => s.unsubscribe());
    }

     getBlock() {
         if(this.mainDocRelated) {
             this.subscriptionsList$.push( this.entityPageService.updateMainEntity.subscribe(solrResponse => {
                 if(solrResponse && solrResponse[this.mainDocRelated]) {
                     if(solrResponse[this.mainDocRelated][0] != this.mainDocRelatedVar) {
                         this.mainDocRelatedVar = solrResponse[this.mainDocRelated][0];
                         this.getBlockByVar(solrResponse[this.mainDocRelated][0]);
                     }
                 } else {
                     this.scripts = null;
                     this.html = null;
                     this.mainDocRelatedVar = '';
                 }

             }))
         } else if(this.uri && this.entityType) {
             this.entityService.getEntityHtml(this.uri, this.entityType)
                 .subscribe(
                     res => {
                          if(res && res.length) {
                               this.scripts = res.match(this.scriptsReg)?.join('') || '';
                               this.html = res;
                               this.loadBlock.emit(true);
                          }else{
                              this.scripts = null;
                              this.html = null;
                              this.mainDocRelatedVar = '';
                          }
                     })
         } else {
            this.getBlockByVar(this.entityVar);
         }

     }

     getBlockByVar(entityVar) {
        if(entityVar){
            this.entityService.getEntityHtmlByEntityVar(entityVar)
                  .subscribe(
                      res => {
                          if(_.isEmpty(res) && this.fallBackEntityVar) {
                              this.getBlockByVar(this.fallBackEntityVar);
							  this.fallBackEntityVar = null;
                          }
                          if(res && res.length) {
                              this.scripts = res.match(this.scriptsReg)?.join('') || '';
                              this.html = res;
                              this.loadBlock.emit(true);
                         }else{
                             this.scripts = null;
                             this.html = null;
                             this.mainDocRelatedVar = '';
                         }
                      })
     }

     }

    ngOnChanges(changes: SimpleChanges): void {
      if (changes['refreshHtml'] || changes['mainDocRelated'] || changes['entityType'] || changes['uri']  || changes['entityVar'] && ((this.entityType && this.uri) || changes['entityVar'])) {
          if (this.resetDataOnChanges) {
              this.html = null;
          }
          this.isSolr ? this.getSolrEntity(this.uri, this.entityVar, false) :   this.getBlock();

        }
    }
}
